import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { FaFileInvoiceDollar, FaChevronDown, FaChevronUp, FaCheckCircle, FaTimesCircle, FaInfoCircle, FaGraduationCap, FaBookOpen, FaPencilRuler, FaArrowRight, FaTimes, FaPrint, FaDownload } from "react-icons/fa";
import { paymentService } from "../../services/paymentService";
import { studentService } from "../../services/studentService";
import { getApiBaseUrl } from "../../config";
import toast from "react-hot-toast";
import html2pdf from "html2pdf.js";

function Payments() {
    const [loading, setLoading] = useState(true);
    const [paymentData, setPaymentData] = useState({
        feeCategories: [],
        scholarships: [],
        paymentHistory: [],
        feeHeadMonths: [],
        academicSession: {},
        paymentRequests: []
    });


    console.log(paymentData)


    const [selectedMonths, setSelectedMonths] = useState({}); // { "categoryId-monthName": amount }
    const [openAccordion, setOpenAccordion] = useState(null); // category ID
    const [showReceiptModal, setShowReceiptModal] = useState(false);
    const [selectedReceipt, setSelectedReceipt] = useState(null);
    console.log("selectesReciep", selectedReceipt)
    const [fetchingReceipt, setFetchingReceipt] = useState(false);
    const [processingPayment, setProcessingPayment] = useState(false);
    const [paymentToken, setPaymentToken] = useState(null);
    const scriptLoadedRef = React.useRef(false);

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const monthsList = React.useMemo(() => {
        if (!paymentData.academicSession?.fromDate || !paymentData.academicSession?.toDate) {
            return [
                "April", "May", "June", "July", "August", "September",
                "October", "November", "December", "January", "February", "March"
            ];
        }

        const start = new Date(paymentData.academicSession.fromDate);
        const end = new Date(paymentData.academicSession.toDate);
        const list = [];
        let current = new Date(start);

        // Standard academic sessions usually span 12 months. 
        // We loop from fromDate month to just before toDate month.
        while (current < end) {
            list.push(monthNames[current.getMonth()]);
            current.setMonth(current.getMonth() + 1);

            // Safety break to prevent infinite loop
            if (list.length > 24) break;
        }

        return list.length > 0 ? list : [
            "April", "May", "June", "July", "August", "September",
            "October", "November", "December", "January", "February", "March"
        ];
    }, [paymentData.academicSession]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchAllData();
    }, []);

    const fetchAllData = async () => {
        try {
            setLoading(true);
            const studentId = localStorage.getItem("selectedStudentId");
            if (!studentId) {
                toast.error("No student selected");
                return;
            }

            const enrollmentResponse = await studentService.getStudentEnrollment(studentId);
            const enrollmentData = Array.isArray(enrollmentResponse.data) ? enrollmentResponse.data[0] : enrollmentResponse.data;

            if (!enrollmentData) {
                toast.error("Enrollment data not found");
                return;
            }

            const enrollmentId = enrollmentData._id;
            const academicSessionId = enrollmentData.academicSession?._id;
            const classId = enrollmentData.class?._id;

            if (!academicSessionId || !classId) {
                toast.error("Session or Class information missing");
                return;
            }

            const [feeCatRes, scholarshipRes, historyRes, requestRes] = await Promise.all([
                paymentService.getAdmissionFeeCategory(academicSessionId, classId, "Monthly"),
                paymentService.getScholarships(enrollmentId, academicSessionId),
                paymentService.getPaymentHistory(enrollmentId, academicSessionId),
                paymentService.getOneTimePayments(enrollmentId)
            ]);


            const categories = Array.isArray(feeCatRes?.data) ? feeCatRes.data : (feeCatRes?.data ? [feeCatRes.data] : []);


            setPaymentData({
                feeCategories: categories,
                scholarships: Array.isArray(scholarshipRes?.data?.scholarships) ? scholarshipRes.data.scholarships : [],
                paymentHistory: Array.isArray(historyRes?.data?.payments) ? historyRes.data.payments : [],
                feeHeadMonths: Array.isArray(historyRes?.data?.feeHeadMonths) ? historyRes.data.feeHeadMonths : [],
                academicSession: historyRes?.data?.academicSession,
                paymentRequests: Array.isArray(requestRes?.data) ? requestRes.data : []
            });

            if (categories.length > 0) {
                setOpenAccordion(categories[0]._id);
            }

        } catch (error) {
            console.error("Error fetching payment data:", error);
            toast.error("Failed to load payment information");
        } finally {
            setLoading(false);
        }
    };

    const calculateMonthlyPayable = (detail) => {
        if (!detail || !detail.feeHead) {
            return {
                baseAmount: 0,
                scholarshipDeduction: 0,
                schemeDeduction: 0,
                totalDeductions: 0,
                payableAmount: 0,
                appliedScholarships: [],
                scholarshipPercentage: 0,
                scholarshipFlatAmount: 0,
                schemePercentage: 0,
                schemeFlatAmount: 0,
                totalDiscountPercentage: 0,
                hasScholarship: false,
                hasScheme: false
            };
        }

        const baseAmount = detail.amount || 0;
        const headName = detail.feeHead.name || "";
        const scholarships = Array.isArray(paymentData.scholarships) ? paymentData.scholarships : [];

        // Get scheme discount from payment history
        // If scheme is null, use discountAmount or discountPercentage based on discountType
        let schemePercentage = 0;
        let schemeFlatAmount = 0;

        if (Array.isArray(paymentData.paymentHistory) && paymentData.paymentHistory.length > 0) {
            paymentData.paymentHistory.forEach(payment => {
                // Check if scheme is null, then use discount fields
                if (payment.scheme === null || payment.scheme === undefined) {
                    const discountType = (payment.discountType || "").toLowerCase();

                    if (discountType === "percentage") {
                        schemePercentage += payment.discountPercentage || 0;
                    } else if (discountType === "flat" || discountType === "fixed") {
                        schemeFlatAmount += payment.discountAmount || 0;
                    }
                } else if (payment.discountPercentage) {
                    // Fallback to old logic if scheme exists
                    schemePercentage += payment.discountPercentage || 0;
                }
            });
        }

        // Match scholarships with fee head name
        const matchingScholarships = scholarships.filter(s =>
            s.isActive &&
            s.paymentType?.toLowerCase().trim() === headName.toLowerCase().trim()
        );

        let scholarshipPercentage = 0;
        let scholarshipFlatAmount = 0;
        const appliedScholarships = [];

        matchingScholarships.forEach(s => {
            let deduction = 0;
            const dType = (s.discountType || "").toLowerCase();

            if (dType === "percentage") {
                deduction = (baseAmount * (s.value || 0)) / 100;
                scholarshipPercentage += (s.value || 0);
            } else {
                // For flat/fixed discounts
                deduction = s.value || 0;
                scholarshipFlatAmount += (s.value || 0);
            }

            appliedScholarships.push({
                ...s,
                deduction
            });
        });


        // Calculate scholarship deduction: percentage-based + flat amount
        const scholarshipPercentageDeduction = (baseAmount * scholarshipPercentage) / 100;
        const scholarshipDeduction = scholarshipPercentageDeduction + scholarshipFlatAmount;

        // Calculate scheme deduction: percentage-based + flat amount
        const schemePercentageDeduction = (baseAmount * schemePercentage) / 100;
        const schemeDeduction = schemePercentageDeduction + schemeFlatAmount;

        // Total discount percentage and deductions
        const totalDiscountPercentage = schemePercentage + scholarshipPercentage;
        const totalDeductions = scholarshipDeduction + schemeDeduction;

        // Check if any scholarship or scheme is applied
        const hasScholarship = scholarshipPercentage > 0 || scholarshipFlatAmount > 0;
        const hasScheme = schemePercentage > 0 || schemeFlatAmount > 0;

        // console.log("Base Amount:", baseAmount);
        // console.log("Scholarship:", scholarshipPercentage + "% = ₹" + scholarshipDeduction);
        // console.log("Scheme:", schemePercentage + "% = ₹" + schemeDeduction);
        // console.log("Total Discount:", totalDiscountPercentage + "% = ₹" + totalDeductions);

        const finalAmount = Math.max(0, baseAmount - totalDeductions);

        return {
            baseAmount,
            scholarshipDeduction,
            schemeDeduction,
            totalDeductions,
            payableAmount: finalAmount,
            appliedScholarships,
            scholarshipPercentage,
            scholarshipFlatAmount,
            schemePercentage,
            schemeFlatAmount,
            totalDiscountPercentage,
            hasScholarship,
            hasScheme
        };
    };

    const isMonthPaid = (detail, monthName) => {
        if (!detail || !detail.feeHead) return false;
        const headId = detail.feeHead?._id || detail.feeHead?.id;
        const headPaidData = paymentData.feeHeadMonths.find(f => (f.feeHead?.id || f.feeHead?._id) === headId);
        return headPaidData?.months?.includes(monthName);
    };

    const handleMonthSelect = (feeItemId, monthName, amount) => {
        const monthIndex = monthsList.indexOf(monthName);
        const selectionKey = `${feeItemId}-${monthName}`;

        setSelectedMonths(prev => {
            const newState = { ...prev };

            if (newState[selectionKey]) {
                delete newState[selectionKey];
                for (let i = monthIndex + 1; i < monthsList.length; i++) {
                    delete newState[`${feeItemId}-${monthsList[i]}`];
                }
            } else {
                newState[selectionKey] = amount;
            }
            return newState;
        });
    };

    const calculateTotal = () => {
        return Object.values(selectedMonths).reduce((acc, curr) => acc + curr, 0);
    };

    const totalAmount = calculateTotal();

    const handleOneTimePayment = (request) => {
        toast.success(`Initiating payment for ${request.feeHead?.name}`);
        // TODO: Integrate actual payment gateway for one-time payments
    };

    // Load NTT DATA checkout script (only once)
    useEffect(() => {
        // Prevent duplicate loading in React Strict Mode
        if (scriptLoadedRef.current) {
            return;
        }

        // Check if script is already loaded or AtomPaynetz is available
        const existingScript = document.querySelector('script[src*="atomcheckout.js"]');
        if (existingScript || window.AtomPaynetz) {
            scriptLoadedRef.current = true;
            if (window.AtomPaynetz) {
                console.log('NTT DATA AtomPaynetz already available');
            }
            return;
        }

        // Mark as loading
        scriptLoadedRef.current = true;

        const script = document.createElement('script');
        script.src = 'https://pgtest.atomtech.in/staticdata/ots/js/atomcheckout.js'; // UAT script
        script.async = true;
        script.id = 'ntt-data-checkout-script'; // Add ID for easy identification
        script.onload = () => {
            console.log('NTT DATA checkout script loaded');
            // Verify AtomPaynetz is available
            if (window.AtomPaynetz) {
                console.log('AtomPaynetz is available');
            } else {
                console.warn('AtomPaynetz not found after script load');
            }
        };
        script.onerror = () => {
            console.error('Failed to load NTT DATA checkout script');
            scriptLoadedRef.current = false; // Reset on error to allow retry
        };

        document.body.appendChild(script);

        // No cleanup - keep script loaded for the session
    }, []);

    const handlePayNow = async () => {
        if (totalAmount === 0) {
            toast.error("Please select at least one month to pay");
            return;
        }

        try {
            setProcessingPayment(true);

            // Extract fee head and months from selectedMonths
            // Since one fee type at a time, all selected months should be for the same fee head
            const selectedKeys = Object.keys(selectedMonths);
            if (selectedKeys.length === 0) {
                toast.error("Please select at least one month to pay");
                setProcessingPayment(false);
                return;
            }

            // Extract fee head ID and months from selectedMonths
            // Structure: { "feeItemId-monthName": amount }
            // feeItemId could be: detail._id OR `${category._id}-${detail.feeHead?._id}`

            // Group selections by fee head
            const feeHeadGroups = {};

            for (const category of paymentData.feeCategories || []) {
                for (const detail of category.feeDetails || []) {
                    const detailId = detail._id || `${category._id}-${detail.feeHead?._id}`;
                    const feeHeadId = detail.feeHead?._id || detail.feeHead?.id;

                    // Find all selected months for this fee detail
                    const monthsForThisFee = selectedKeys
                        .filter(key => {
                            // Check if key starts with detailId followed by a hyphen
                            return key.startsWith(`${detailId}-`);
                        })
                        .map(key => {
                            // Extract month name (everything after the last hyphen)
                            const parts = key.split('-');
                            return parts[parts.length - 1];
                        });

                    if (monthsForThisFee.length > 0) {
                        if (!feeHeadGroups[feeHeadId]) {
                            feeHeadGroups[feeHeadId] = {
                                feeHeadId,
                                months: [],
                                detail
                            };
                        }
                        feeHeadGroups[feeHeadId].months.push(...monthsForThisFee);
                    }
                }
            }

            // Since one fee type at a time, get the first (and should be only) fee head
            const feeHeadEntries = Object.values(feeHeadGroups);
            if (feeHeadEntries.length === 0) {
                toast.error("No valid fee selection found");
                setProcessingPayment(false);
                return;
            }

            if (feeHeadEntries.length > 1) {
                toast.error("Please select months for only one fee type at a time");
                setProcessingPayment(false);
                return;
            }

            const selectedFeeHead = feeHeadEntries[0];
            const feeHeadId = selectedFeeHead.feeHeadId;
            const months = [...new Set(selectedFeeHead.months)]; // Remove duplicates

            if (!feeHeadId) {
                toast.error("Fee head not found");
                setProcessingPayment(false);
                return;
            }

            // Get enrollment ID
            const studentId = localStorage.getItem("selectedStudentId");
            if (!studentId) {
                toast.error("Student information not found");
                setProcessingPayment(false);
                return;
            }

            const enrollmentResponse = await studentService.getStudentEnrollment(studentId);
            const enrollmentData = Array.isArray(enrollmentResponse.data) ? enrollmentResponse.data[0] : enrollmentResponse.data;
            const enrollmentId = enrollmentData?._id;

            if (!enrollmentId) {
                toast.error("Enrollment information not found");
                setProcessingPayment(false);
                return;
            }

            // Initiate payment
            const response = await paymentService.initiatePayment({
                enrollmentId,
                feeHeadId,
                months,
                // paymentType: "Other Fee"
            });

            if (response.success && response.data) {
                const { tokenId, transactionId } = response.data;

                if (!tokenId) {
                    toast.error("Payment token not received");
                    setProcessingPayment(false);
                    return;
                }

                setPaymentToken(tokenId);

                // Open NTT DATA payment popup using AtomPaynetz (as per working sample)
                if (window.AtomPaynetz) {
                    // Get student details for customer info
                    const studentId = localStorage.getItem("selectedStudentId");
                    const enrollmentResponse = await studentService.getStudentEnrollment(studentId);
                    const enrollmentData = Array.isArray(enrollmentResponse.data) ? enrollmentResponse.data[0] : enrollmentResponse.data;
                    const student = enrollmentData?.student;

                    // const customerEmail = student?.email || student?.parentEmail || "";
                    const customerEmail = 'diggdiganta@gmail.com';
                    // let customerMobile = student?.phone || student?.parentPhone || "";
                    let customerMobile = '9508632462';

                    // Format and validate mobile number (NTT DATA requires 10-digit Indian mobile number)
                    // Remove any non-digit characters
                    customerMobile = customerMobile.replace(/\D/g, '');

                    // If mobile starts with country code (91), remove it
                    if (customerMobile.startsWith('91') && customerMobile.length === 12) {
                        customerMobile = customerMobile.substring(2);
                    }

                    // Validate mobile number (should be 10 digits)
                    if (!customerMobile || customerMobile.length !== 10) {
                        toast.error("Please ensure student/parent has a valid 10-digit mobile number");
                        setProcessingPayment(false);
                        return;
                    }

                    // Validate email
                    if (!customerEmail || !customerEmail.includes('@')) {
                        toast.error("Please ensure student/parent has a valid email address");
                        setProcessingPayment(false);
                        return;
                    }

                    // Return URL should point to backend endpoint that will redirect to frontend
                    // Use the same base URL as the payment service
                    const returnUrl = `${getApiBaseUrl()}/payments/return`; // Backend endpoint that redirects to frontend

                    // Options for AtomPaynetz (as per working sample)
                    const options = {
                        atomTokenId: String(tokenId),
                        merchId: "445842", // UAT merchant ID
                        custEmail: customerEmail,
                        custMobile: customerMobile, // 10-digit mobile number
                        returnUrl: returnUrl
                    };

                    console.log("Opening AtomPaynetz with options:", options);

                    // Open payment popup (as per NTT DATA sample: new AtomPaynetz(options, env))
                    // eslint-disable-next-line no-new
                    new window.AtomPaynetz(options, "uat");

                    // Note: AtomPaynetz handles callbacks internally via returnUrl
                    // The payment status will be updated via the callback API on the backend
                    setProcessingPayment(false);

                    // Refresh payment data after a delay (to allow for callback processing)
                    setTimeout(async () => {
                        await fetchAllData();
                        setSelectedMonths({});
                    }, 3000);
                } else {
                    console.error("AtomPaynetz not available. window.AtomPaynetz:", window.AtomPaynetz);
                    toast.error("Payment gateway script not loaded. Please refresh the page.");
                    setProcessingPayment(false);
                }
            } else {
                toast.error(response.message || "Failed to initiate payment");
                setProcessingPayment(false);
            }
        } catch (error) {
            console.error("Payment initiation error:", error);
            toast.error(error.response?.data?.message || error.message || "Failed to initiate payment");
            setProcessingPayment(false);
        }
    };

    const handlePrint = () => {
        const printStyles = `
            @media print {
                html, body { 
                    margin: 0 !important; 
                    padding: 0 !important; 
                    background: white !important;
                    -webkit-print-color-adjust: exact;
                }
                body * { visibility: hidden !important; }
                #printable-content, #printable-content * { visibility: visible !important; }
                #printable-content { 
                    position: static !important;
                    width: calc(100% - 20mm) !important; 
                    margin: 10mm auto !important; 
                    padding: 0 !important;
                    border: none !important;
                    box-shadow: none !important;
                }
                .print-compact-section { 
                    margin-bottom: 12px !important; 
                    padding-bottom: 8px !important; 
                }
                .print-compact-row { 
                    padding-top: 4px !important; 
                    padding-bottom: 4px !important; 
                    font-size: 10pt !important;
                }
                @page { margin: 0; size: auto; }
            }
        `;
        const styleSheet = document.createElement("style");
        styleSheet.innerText = printStyles;
        document.head.appendChild(styleSheet);

        window.print();

        document.head.removeChild(styleSheet);
    };

    const handleDownloadPDF = async () => {
        const element = document.getElementById('printable-content');
        if (!element) return;

        const originalStyle = element.style.cssText;
        // Force consistent width for capture regardless of screen size
        element.style.width = '800px';
        element.style.boxShadow = 'none';
        element.style.margin = '0 auto';

        const opt = {
            margin: 10,
            filename: `${selectedReceipt.isStatement ? 'Statement' : 'Receipt'}_${selectedReceipt.receiptNo}.pdf`,
            image: { type: 'jpeg', quality: 1.0 },
            html2canvas: {
                scale: 2,
                useCORS: true,
                letterRendering: true,
                backgroundColor: '#ffffff',
                logging: false,
                width: 800,
                scrollY: -window.scrollY,
                windowWidth: 800
            },
            jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
            pagebreak: { mode: ['avoid-all', 'css', 'legacy'] }
        };

        try {
            setFetchingReceipt(true);
            const toastId = toast.loading("Generating PDF...");
            await html2pdf().from(element).set(opt).save();
            toast.dismiss(toastId);
            toast.success("PDF Downloaded successfully");
        } catch (error) {
            console.error("PDF generation error:", error);
            toast.error("Failed to generate PDF");
        } finally {
            element.style.cssText = originalStyle;
            setFetchingReceipt(false);
        }
    };

    const handleViewStatement = async () => {
        if (!paymentData.paymentHistory || paymentData.paymentHistory.length === 0) {
            toast.error("No payment history available to generate statement");
            return;
        }

        try {
            setFetchingReceipt(true);
            // Fetch first receipt to get school and student metadata
            const firstId = paymentData.paymentHistory[0]._id;
            const response = await paymentService.getReceiptData(firstId);

            if (response.success) {
                const baseData = response.data;
                console.log("baseData", baseData)

                // Construct Consolidated Data from history
                const consolidatedData = {
                    ...baseData,
                    isStatement: true
                };

                console.log("consolidate", consolidatedData)

                setSelectedReceipt(consolidatedData);
                setShowReceiptModal(true);
            } else {
                toast.error("Failed to generate statement metadata");
            }
        } catch (error) {
            console.error("Error creating statement:", error);
            toast.error("Failed to load statement view");
        } finally {
            setFetchingReceipt(false);
        }
    };



    if (loading) {
        return (
            <div className="min-h-screen bg-white flex flex-col items-center justify-center p-6">
                <div className="relative w-32 h-32 mb-8">
                    {/* Background Glow */}
                    <motion.div
                        className="absolute inset-0 bg-pragyaBlue/10 rounded-full blur-2xl"
                        animate={{
                            scale: [1, 1.2, 1],
                            opacity: [0.5, 0.8, 0.5]
                        }}
                        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
                    />

                    {/* Central Icon */}
                    <motion.div
                        className="absolute inset-0 flex items-center justify-center bg-white rounded-3xl shadow-xl border border-slate-50 z-10"
                        animate={{ y: [0, -10, 0] }}
                        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                    >
                        <FaGraduationCap className="text-4xl text-pragyaBlue" />
                    </motion.div>

                    {/* Orbiting Icons */}
                    <motion.div
                        className="absolute -top-4 -right-4 w-10 h-10 bg-pragyaOrange/10 rounded-xl flex items-center justify-center text-pragyaOrange"
                        animate={{ rotate: 360 }}
                        transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
                    >
                        <FaBookOpen />
                    </motion.div>

                    <motion.div
                        className="absolute -bottom-2 -left-4 w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center text-green-600"
                        animate={{ rotate: -360 }}
                        transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
                    >
                        <FaPencilRuler />
                    </motion.div>
                </div>

                <div className="text-center">
                    <motion.h3
                        className="text-lg font-bold text-slate-800 mb-2"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.2 }}
                    >
                        Preparing Your Dashboard
                    </motion.h3>

                    <div className="flex flex-col items-center gap-2">
                        <div className="w-48 h-1.5 bg-slate-100 rounded-full overflow-hidden">
                            <motion.div
                                className="h-full bg-pragyaBlue"
                                initial={{ width: "0%" }}
                                animate={{ width: "100%" }}
                                transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
                            />
                        </div>
                        <motion.p
                            className="text-xs text-slate-400 font-medium"
                            animate={{ opacity: [0.4, 1, 0.4] }}
                            transition={{ duration: 2, repeat: Infinity }}
                        >
                            Syncing classroom records...
                        </motion.p>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <motion.div
            className="min-h-screen bg-slate-50 p-4 pb-48"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
        >
            <div className="flex justify-between items-center mb-6">
                <div>
                    <h1 className="text-2xl font-bold text-slate-800">Payments</h1>
                    <p className="text-xs text-slate-500 mt-1 mr-20">Manage your school fees and scholarships</p>
                </div>

                <button
                    onClick={handleViewStatement}
                    className="flex items-center gap-2 bg-pragyaBlue text-white px-4 py-2.5 rounded-xl text-sm font-bold hover:shadow-lg hover:shadow-pragyaBlue/20 transition-all active:scale-95 shadow-md"
                >
                    <FaFileInvoiceDollar className="text-sm" />
                    Receipt
                </button>
            </div>

            {Array.isArray(paymentData.paymentRequests) && paymentData.paymentRequests.length > 0 && (
                <div className="mb-8">
                    <h2 className="text-sm uppercase tracking-wider text-slate-500 font-semibold mb-3">One-Time Fees</h2>
                    <div className="space-y-3">
                        {paymentData.paymentRequests.map((request, index) => {
                            const isPaid = request.status === "Paid" || request.status === "Approved";
                            return (
                                <div key={request._id || index} className="bg-white p-4 rounded-xl border border-slate-100 shadow-sm flex justify-between items-center">
                                    <div>
                                        <p className="font-medium text-slate-800">{request.feeHead?.name || "Fee"}</p>
                                        <p className="text-xs text-slate-400">
                                            Status: <span className={`font-medium ${isPaid ? "text-green-600" : "text-amber-500"}`}>
                                                {request.status || "Pending"}
                                            </span>
                                        </p>
                                    </div>
                                    <div className="flex items-center gap-2">
                                        <span className="font-semibold text-slate-900">₹{request.requestedAmount || 0}</span>
                                        {isPaid ? (
                                            <div className="flex items-center gap-1.5 px-3 py-1.5 bg-green-50 text-green-600 rounded-full border border-green-100">
                                                <FaCheckCircle className="text-xs" />
                                                <span className="text-xs font-bold">PAID</span>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={() => handleOneTimePayment(request)}
                                                className="group flex items-center gap-2 bg-pragyaBlue text-white text-[10px] uppercase tracking-wide font-bold px-4 py-2 rounded-full shadow-sm hover:shadow-md hover:opacity-90 hover:-translate-y-0.5 active:translate-y-0 active:scale-95 transition-all duration-200"
                                            >
                                                <span>Pay</span>
                                                <FaArrowRight className="group-hover:translate-x-0.5 transition-transform duration-200" />
                                            </button>
                                        )}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            <div>
                <h2 className="text-sm uppercase tracking-wider text-slate-500 font-semibold mb-3">Tuition & Recurring Fees</h2>

                <div className="space-y-4">
                    {paymentData.feeCategories?.length > 0 ? (
                        paymentData.feeCategories.flatMap(category =>
                            category.feeDetails.map(detail => {
                                const feeItemId = detail._id || `${category._id}-${detail.feeHead?._id}`;
                                const report = calculateMonthlyPayable(detail);
                                const isActive = openAccordion === feeItemId;

                                return (
                                    <div key={feeItemId} className="bg-white rounded-xl border border-slate-200 shadow-sm overflow-hidden">
                                        <button
                                            onClick={() => setOpenAccordion(isActive ? null : feeItemId)}
                                            className={`w-full flex items-center justify-between p-4 transition-colors ${isActive ? 'bg-slate-50' : 'bg-white'}`}
                                        >
                                            <div className="flex flex-col items-start text-left">
                                                <span className="font-semibold text-slate-800 text-lg">
                                                    {detail.feeHead?.name || "Fee Head"}
                                                </span>
                                                <div className="flex items-center gap-2 mt-1">
                                                    {report.totalDeductions > 0 ? (
                                                        <>
                                                            <span className="text-xs font-bold text-pragyaBlue bg-pragyaBlue/10 px-2 py-0.5 rounded">
                                                                ₹{report.payableAmount}/month
                                                            </span>
                                                            <span className="text-[10px] text-slate-400 line-through">
                                                                ₹{report.baseAmount}
                                                            </span>
                                                            <span className="text-[10px] text-green-600 font-bold bg-green-50 px-1.5 py-0.5 rounded border border-green-100">
                                                                SAVE ₹{Math.round(report.totalDeductions)}
                                                            </span>
                                                        </>
                                                    ) : (
                                                        <span className="text-xs font-bold text-slate-600 bg-slate-100 px-2 py-0.5 rounded">
                                                            ₹{report.payableAmount}/month
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {isActive ? (
                                                <FaChevronUp className="text-slate-400" />
                                            ) : (
                                                <FaChevronDown className="text-slate-400" />
                                            )}
                                        </button>

                                        <AnimatePresence>
                                            {isActive && (
                                                <motion.div
                                                    initial={{ height: 0, opacity: 0 }}
                                                    animate={{ height: "auto", opacity: 1 }}
                                                    exit={{ height: 0, opacity: 0 }}
                                                    transition={{ duration: 0.2 }}
                                                >
                                                    <div className="p-4 border-t border-slate-100 bg-white">
                                                        <div className="mb-4 p-3 bg-slate-50 rounded-lg border border-slate-100">
                                                            <div className="flex items-start gap-2 mb-2">
                                                                <FaInfoCircle className="text-slate-400 mt-0.5" />
                                                                <span className="text-xs font-semibold text-slate-600 uppercase">Fee Breakdown</span>
                                                            </div>
                                                            <div className="space-y-1">
                                                                <div className="flex justify-between text-xs text-slate-500">
                                                                    <span>Base Amount</span>
                                                                    <span>₹{report.baseAmount}</span>
                                                                </div>

                                                                {/* Scholarship Discount Section */}
                                                                {report.hasScholarship && (
                                                                    <div className="mt-2 pt-2 border-t border-dashed border-slate-200">
                                                                        <div className="bg-blue-50 px-3 py-2 rounded-lg border border-blue-100">
                                                                            <div className="flex items-center justify-between mb-1">
                                                                                <span className="text-[10px] font-bold text-blue-700 uppercase">📚 Scholarship Discount</span>
                                                                                <div className="flex items-center gap-1">
                                                                                    {report.scholarshipPercentage > 0 && (
                                                                                        <span className="text-xs font-black text-blue-700">{report.scholarshipPercentage}%</span>
                                                                                    )}
                                                                                    {report.scholarshipFlatAmount > 0 && (
                                                                                        <span className="text-xs font-black text-blue-700">
                                                                                            {report.scholarshipPercentage > 0 && " + "}₹{report.scholarshipFlatAmount}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex items-center justify-between">
                                                                                <span className="text-[9px] text-blue-600">
                                                                                    {report.scholarshipPercentage > 0 && report.scholarshipFlatAmount > 0
                                                                                        ? "Combined discount applied"
                                                                                        : report.scholarshipPercentage > 0
                                                                                            ? "Applied on base amount"
                                                                                            : "Flat discount applied"}
                                                                                </span>
                                                                                <span className="text-xs font-bold text-blue-700">-₹{Math.round(report.scholarshipDeduction)}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Scheme Discount Section */}
                                                                {report.hasScheme && (
                                                                    <div className="mt-2 pt-2 border-t border-dashed border-slate-200">
                                                                        <div className="bg-purple-50 px-3 py-2 rounded-lg border border-purple-100">
                                                                            <div className="flex items-center justify-between mb-1">
                                                                                <span className="text-[10px] font-bold text-purple-700 uppercase">🎓 Scheme Discount</span>
                                                                                <div className="flex items-center gap-1">
                                                                                    {report.schemePercentage > 0 && (
                                                                                        <span className="text-xs font-black text-purple-700">{report.schemePercentage}%</span>
                                                                                    )}
                                                                                    {report.schemeFlatAmount > 0 && (
                                                                                        <span className="text-xs font-black text-purple-700">
                                                                                            {report.schemePercentage > 0 && " + "}₹{report.schemeFlatAmount}
                                                                                        </span>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                            <div className="flex items-center justify-between">
                                                                                <span className="text-[9px] text-purple-600">
                                                                                    {report.schemePercentage > 0 && report.schemeFlatAmount > 0
                                                                                        ? "Combined discount applied"
                                                                                        : report.schemePercentage > 0
                                                                                            ? "Applied on base amount"
                                                                                            : "Flat discount applied"}
                                                                                </span>
                                                                                <span className="text-xs font-bold text-purple-700">-₹{Math.round(report.schemeDeduction)}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* Total Discount Summary */}
                                                                {report.totalDiscountPercentage > 0 && (
                                                                    <div className="mt-2 pt-2 border-t border-dashed border-green-200">
                                                                        <div className="bg-green-50 px-3 py-2.5 rounded-lg border border-green-200">
                                                                            <div className="flex items-center justify-between mb-1.5">
                                                                                <span className="text-[10px] font-bold text-green-800 uppercase">💰 Total Discount Applied</span>
                                                                                <span className="text-sm font-black text-green-800">{report.totalDiscountPercentage}%</span>
                                                                            </div>
                                                                            <div className="flex items-center justify-between">
                                                                                <span className="text-[9px] text-green-700 font-medium">You save in total</span>
                                                                                <span className="text-sm font-black text-green-800">₹{Math.round(report.totalDeductions)}</span>
                                                                            </div>
                                                                            <div className="mt-1.5 pt-1.5 border-t border-green-200">
                                                                                <p className="text-[8px] text-green-700 leading-tight">
                                                                                    ℹ️ Both discounts are calculated separately from the base amount and then combined.
                                                                                </p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                <div className="border-t border-slate-200 mt-1 pt-1 flex justify-between text-sm font-bold text-slate-700">
                                                                    <span>Net Monthly Payable</span>
                                                                    <span>₹{report.payableAmount}</span>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div className="grid grid-cols-2 xs:grid-cols-3 sm:grid-cols-4 gap-3">
                                                            {monthsList.map((month, index) => {
                                                                const paid = isMonthPaid(detail, month);
                                                                const selectionKey = `${feeItemId}-${month}`;
                                                                const isSelected = !!selectedMonths[selectionKey];

                                                                let isDisabled = false;
                                                                if (index > 0) {
                                                                    const prevMonth = monthsList[index - 1];
                                                                    const isPrevPaid = isMonthPaid(detail, prevMonth);
                                                                    const isPrevSelected = !!selectedMonths[`${feeItemId}-${prevMonth}`];
                                                                    if (!isPrevPaid && !isPrevSelected) {
                                                                        isDisabled = true;
                                                                    }
                                                                }

                                                                return (
                                                                    <label
                                                                        key={index}
                                                                        className={`
                                                                            flex flex-col items-center justify-center p-3 h-24 rounded-xl border transition-all relative
                                                                            ${paid
                                                                                ? 'bg-pragyaBlue/10 border-pragyaBlue/20 text-pragyaBlue/80 cursor-default'
                                                                                : isDisabled
                                                                                    ? 'bg-slate-50 border-slate-100 text-slate-300 cursor-not-allowed'
                                                                                    : isSelected
                                                                                        ? 'bg-pragyaBlue/10 border-pragyaBlue text-pragyaBlue cursor-pointer shadow-md transform scale-[1.02]'
                                                                                        : 'bg-white border-slate-200 text-slate-600 hover:border-pragyaBlue/50 cursor-pointer hover:shadow-sm'
                                                                            }
                                                                        `}
                                                                    >
                                                                        <div className="absolute top-2 right-2">
                                                                            {paid ? (
                                                                                <FaCheckCircle className="text-pragyaBlue text-xs" />
                                                                            ) : (
                                                                                <input
                                                                                    type="checkbox"
                                                                                    checked={isSelected}
                                                                                    disabled={isDisabled}
                                                                                    onChange={() => handleMonthSelect(feeItemId, month, report.payableAmount)}
                                                                                    className={`w-4 h-4 rounded border-gray-300 text-pragyaBlue focus:ring-pragyaBlue accent-pragyaBlue ${isDisabled ? 'cursor-not-allowed opacity-50' : ''}`}
                                                                                />
                                                                            )}
                                                                        </div>

                                                                        <div className="flex flex-col items-center mt-2 w-full">
                                                                            <span className="text-sm font-medium mb-1">{month}</span>
                                                                            <div className="flex flex-col items-center gap-0">
                                                                                {paid ? (
                                                                                    <span className="text-[10px] font-bold text-pragyaBlue bg-pragyaBlue/10 px-2 py-0.5 rounded-full">
                                                                                        PAID
                                                                                    </span>
                                                                                ) : (
                                                                                    <>
                                                                                        {report.totalDeductions > 0 && (
                                                                                            <span className="text-[9px] text-slate-400 line-through">₹{report.baseAmount}</span>
                                                                                        )}
                                                                                        <span className={`text-[11px] font-semibold ${isSelected ? 'text-pragyaBlue' : 'text-slate-600'}`}>
                                                                                            ₹{report.payableAmount}
                                                                                        </span>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </label>
                                                                );
                                                            })}
                                                        </div>
                                                    </div>
                                                </motion.div>
                                            )}
                                        </AnimatePresence>
                                    </div>
                                );
                            })
                        )
                    ) : (
                        <div className="bg-white p-8 rounded-xl border border-slate-200 text-center">
                            <p className="text-slate-400 text-sm">No monthly fee structures assigned.</p>
                        </div>
                    )}
                </div>
            </div>

            {/* Receipt View Modal */}
            <AnimatePresence>
                {showReceiptModal && selectedReceipt && (
                    <div className="fixed inset-0 z-[60] flex items-center justify-center p-0 sm:p-4 bg-black/70 backdrop-blur-md overflow-hidden">
                        <motion.div
                            initial={{ scale: 0.9, opacity: 0, y: 50 }}
                            animate={{ scale: 1, opacity: 1, y: 0 }}
                            exit={{ scale: 0.9, opacity: 0, y: 50 }}
                            className="bg-white w-full h-full sm:h-auto sm:max-h-[92vh] sm:max-w-4xl shadow-2xl flex flex-col sm:rounded-2xl overflow-hidden"
                        >
                            {/* Sticky Header for Controls */}
                            <div className="p-4 bg-slate-900 text-white flex justify-between items-center print:hidden shrink-0 z-10">
                                <div className="flex items-center gap-3">
                                    <div className="w-9 h-9 sm:w-10 sm:h-10 bg-pragyaBlue rounded-lg flex items-center justify-center shadow-lg shadow-pragyaBlue/20">
                                        <FaFileInvoiceDollar className="text-lg" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-xs sm:text-sm">{selectedReceipt.isStatement ? "Consolidated Statement" : "Payment Receipt"}</h3>
                                        <p className="text-[9px] sm:text-[10px] text-slate-400 font-mono">{selectedReceipt.receiptNo}</p>
                                    </div>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={handleDownloadPDF}
                                        disabled={fetchingReceipt}
                                        className="flex items-center gap-2 bg-pragyaBlue hover:bg-opacity-90 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-[10px] sm:text-xs font-black transition-all shadow-lg active:scale-95 disabled:opacity-50"
                                    >
                                        <FaDownload /> {fetchingReceipt ? "GENERATING..." : "DOWNLOAD PDF"}
                                    </button>
                                    <button
                                        onClick={handlePrint}
                                        className="hidden sm:flex items-center gap-2 bg-slate-800 hover:bg-slate-700 px-3 py-1.5 sm:px-4 sm:py-2 rounded-lg text-[10px] sm:text-xs font-black transition-all active:scale-95 border border-slate-700"
                                    >
                                        <FaPrint /> PRINT
                                    </button>
                                    <button
                                        onClick={() => setShowReceiptModal(false)}
                                        className="p-2 hover:bg-slate-800 rounded-full transition-colors text-slate-400 hover:text-white"
                                    >
                                        <FaTimes />
                                    </button>
                                </div>
                            </div>

                            {/* Scrollable Receipt Area */}
                            <div className="flex-1 overflow-y-auto bg-slate-900/10 p-2 sm:p-8 print:p-0 print:bg-white custom-scrollbar flex justify-center">
                                <div id="printable-content" className="bg-white w-full max-w-[800px] shadow-2xl rounded-sm print:shadow-none print:max-w-none print:m-0 print:p-0">
                                    <div className="border-[6px] border-double border-slate-200 p-4 sm:p-8 relative overflow-hidden bg-white print:p-2 print:border-none print-no-padding">
                                        {/* Watermark for Statements */}
                                        {selectedReceipt.isStatement && (
                                            <div className="absolute inset-0 flex items-center justify-center opacity-[0.03] pointer-events-none select-none rotate-[30deg]">
                                                <span className="text-6xl sm:text-8xl font-black text-slate-900">STATEMENT</span>
                                            </div>
                                        )}

                                        {/* School Header */}
                                        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 mb-6 pb-6 border-b-2 border-slate-100 relative z-10 print-compact-section">
                                            <div className="flex flex-col items-center sm:items-start text-center sm:text-left">
                                                {selectedReceipt.school?.logoUrl ? (
                                                    <img src={selectedReceipt.school.logoUrl} alt="School Logo" className="h-14 mb-2 object-contain" />
                                                ) : (
                                                    <div className="w-14 h-14 bg-pragyaBlue rounded-xl flex items-center justify-center mb-2">
                                                        <FaGraduationCap className="text-2xl text-white" />
                                                    </div>
                                                )}
                                                <h2 className="text-xl font-black text-slate-900 uppercase tracking-tight line-height-1.2">{selectedReceipt.school?.name}</h2>
                                                <p className="text-[10px] font-bold text-pragyaBlue uppercase tracking-[0.2em]">{selectedReceipt.school?.tagLine}</p>
                                            </div>
                                            <div className="text-center sm:text-right text-[10px] text-slate-500 space-y-0.5">
                                                <p className="font-semibold text-slate-700">{selectedReceipt.school?.address?.line1}</p>
                                                <p>{selectedReceipt.school?.address?.city}, {selectedReceipt.school?.address?.district?.name}</p>
                                                <p>{selectedReceipt.school?.address?.state?.name} - {selectedReceipt.school?.address?.pinCode}</p>
                                                <p className="pt-1 font-bold text-slate-800">Email: {selectedReceipt.school?.contact?.email}</p>
                                                <p className="font-bold text-slate-800">Phone: {selectedReceipt.school?.contact?.phone}</p>
                                            </div>
                                        </div>

                                        {/* Receipt Info & Student Info Grid */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6 print-compact-section">
                                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                                                <h4 className="text-[9px] uppercase font-black text-slate-400 mb-2 tracking-widest border-b border-slate-200 pb-1">Receipt Details</h4>
                                                <div className="space-y-1.5">
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Receipt No:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.receiptNo}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Date:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{new Date(selectedReceipt.date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' })}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Type:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.paymentType}</span>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                                                <h4 className="text-[9px] uppercase font-black text-slate-400 mb-2 tracking-widest border-b border-slate-200 pb-1">Student Info</h4>
                                                <div className="space-y-1.5">
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Name:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.student?.name}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Class:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.student?.class}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Roll No:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.student?.rollNo}</span>
                                                    </div>
                                                    <div className="flex justify-between">
                                                        <span className="text-[10px] text-slate-500">Section:</span>
                                                        <span className="text-[10px] font-bold text-slate-900">{selectedReceipt.student?.section}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Fee Breakdown Table */}
                                        <div className="mb-6 overflow-hidden border border-slate-200 rounded-xl print-compact-section">
                                            <table className="w-full text-left border-collapse">
                                                <thead>
                                                    <tr className="bg-slate-900 text-white">
                                                        <th className="px-4 py-2 text-[9px] font-black uppercase tracking-widest">S.No</th>
                                                        <th className="px-4 py-2 text-[9px] font-black uppercase tracking-widest">Description</th>
                                                        <th className="px-4 py-2 text-[9px] font-black uppercase tracking-widest text-right">Amount (₹)</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="divide-y divide-slate-100">
                                                    {selectedReceipt.paymentDetails?.map((item, idx) => (
                                                        <tr key={idx} className="hover:bg-slate-50">
                                                            <td className="px-4 py-1.5 text-[10px] font-medium text-slate-500 print-compact-row">{idx + 1}</td>
                                                            <td className="px-4 py-1.5 text-[10px] font-bold text-slate-800 print-compact-row">
                                                                <div className="flex flex-col">
                                                                    <span>{item.head}</span>
                                                                    {item.date && (
                                                                        <span className="text-[8px] text-slate-400 font-medium">Paid: {new Date(item.date).toLocaleDateString()}</span>
                                                                    )}
                                                                </div>
                                                            </td>
                                                            <td className="px-4 py-1.5 text-[10px] font-black text-slate-900 text-right print-compact-row">₹{item.amount.toLocaleString('en-IN')}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr className="bg-slate-50 border-t-2 border-slate-200">
                                                        <td colSpan="2" className="px-4 py-2 text-[10px] font-black text-slate-900 text-right uppercase">Sub Total</td>
                                                        <td className="px-4 py-2 text-[10px] font-black text-slate-900 text-right">₹{(selectedReceipt.summary?.totalAmount || 0).toLocaleString('en-IN')}</td>
                                                    </tr>
                                                    {(selectedReceipt.summary?.discountAmount || 0) > 0 && (
                                                        <tr className="bg-white border-t border-slate-100">
                                                            <td colSpan="2" className="px-4 py-2 text-[10px] font-bold text-green-600 text-right uppercase">Discount</td>
                                                            <td className="px-4 py-2 text-[10px] font-black text-green-600 text-right">-₹{(selectedReceipt.summary?.discountAmount || 0).toLocaleString('en-IN')}</td>
                                                        </tr>
                                                    )}
                                                    <tr className="bg-white border-t border-slate-100">
                                                        <td colSpan="2" className="px-4 py-2 text-[10px] font-bold font-black text-slate-900 text-right uppercase">Total</td>
                                                        <td className="px-4 py-2 text-[10px] font-black text-slate-900 text-right">₹{(Number(selectedReceipt.summary?.totalAmount) - Number(selectedReceipt.summary?.discountAmount) || 0).toLocaleString('en-IN')}</td>
                                                    </tr>
                                                    <tr className="bg-pragyaBlue text-white">
                                                        <td colSpan="2" className="px-4 py-2.5 text-xs font-black text-right uppercase tracking-widest leading-none">Net Paid</td>
                                                        <td className="px-4 py-2.5 text-base font-black text-right leading-none">₹{(selectedReceipt.summary?.paidAmount || 0).toLocaleString('en-IN')}</td>
                                                    </tr>
                                                    {(selectedReceipt.summary?.remainingBalance || 0) > 0 && (
                                                        <tr className="bg-amber-50 border-t border-amber-100">
                                                            <td colSpan="2" className="px-4 py-2 text-[10px] font-bold text-amber-700 text-right uppercase">Remaining Balance</td>
                                                            <td className="px-4 py-2 text-[10px] font-black text-amber-700 text-right">₹{(selectedReceipt.summary?.remainingBalance || 0).toLocaleString('en-IN')}</td>
                                                        </tr>
                                                    )}
                                                </tfoot>
                                            </table>
                                        </div>

                                        {/* Transaction History / Collections Table */}
                                        {selectedReceipt.collections && selectedReceipt.collections.length > 0 && (
                                            <div className="mb-6 overflow-hidden border border-slate-200 rounded-xl print-compact-section">
                                                <div className="bg-slate-50 px-4 py-2 border-b border-slate-200">
                                                    <h3 className="text-[9px] font-black text-slate-700 uppercase tracking-widest">Transaction History</h3>
                                                </div>
                                                <table className="w-full text-left border-collapse">
                                                    <thead>
                                                        <tr className="bg-slate-100">
                                                            <th className="px-4 py-2 text-[8px] font-black uppercase tracking-widest text-slate-500">Date</th>
                                                            <th className="px-4 py-2 text-[8px] font-black uppercase tracking-widest text-slate-500">Receipt No</th>
                                                            <th className="px-4 py-2 text-[8px] font-black uppercase tracking-widest text-slate-500">Method</th>
                                                            <th className="px-4 py-2 text-[8px] font-black uppercase tracking-widest text-slate-500 text-right">Amount (₹)</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="divide-y divide-slate-100">
                                                        {selectedReceipt.collections.map((col, idx) => (
                                                            <tr key={idx} className="hover:bg-slate-50">
                                                                <td className="px-4 py-1.5 text-[10px] text-slate-600 font-medium">
                                                                    {new Date(col.dateCollected).toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                                                                </td>
                                                                <td className="px-4 py-1.5 text-[10px] font-bold text-slate-700 font-mono tracking-tighter">{col.receiptNo}</td>
                                                                <td className="px-4 py-1.5 text-[10px] font-medium text-slate-600 uppercase italic">{col.paymentMethod}</td>
                                                                <td className="px-4 py-1.5 text-[10px] font-black text-slate-900 text-right">₹{col.paidBalanceAmount.toLocaleString('en-IN')}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}

                                        {/* Payment Method & Transaction */}
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-8 print-compact-section">
                                            <div className="bg-slate-50 p-4 rounded-xl border border-slate-100">
                                                <div className="space-y-2">
                                                    <div className="flex items-center gap-3">
                                                        <FaCheckCircle className="text-green-500 text-sm" />
                                                        <div>
                                                            <p className="text-[8px] text-slate-400 font-bold uppercase">Transaction ID</p>
                                                            <p className="text-[10px] font-black text-slate-800">{selectedReceipt.summary?.transactionId || 'N/A'}</p>
                                                        </div>
                                                    </div>
                                                    <div className="flex items-center gap-3">
                                                        <div className="w-4 h-4 rounded-full bg-pragyaBlue/20 flex items-center justify-center text-[6px] text-pragyaBlue font-bold">●</div>
                                                        <div>
                                                            <p className="text-[8px] text-slate-400 font-bold uppercase">Method</p>
                                                            <p className="text-[10px] font-black text-slate-800">{selectedReceipt.summary?.paymentMethod || 'CASH'}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="flex flex-col justify-end items-center sm:items-end p-2">
                                                <div className="text-center w-32">
                                                    {selectedReceipt.school?.sealUrl ? (
                                                        <img src={selectedReceipt.school.sealUrl} alt="School Seal" className="h-14 mx-auto mb-1 opacity-80" />
                                                    ) : (
                                                        <div className="h-14 w-14 border-2 border-dashed border-slate-200 rounded-full mx-auto mb-1 flex items-center justify-center text-[8px] text-slate-300 font-bold italic">SEAL</div>
                                                    )}
                                                    <div className="border-t border-slate-900 pt-1">
                                                        <p className="text-[8px] font-black text-slate-900 uppercase">Authorized Signatory</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        {/* Footer Message */}
                                        <div className="text-center border-t border-slate-100 pt-6">
                                            <p className="text-[9px] font-black text-slate-900 uppercase tracking-widest mb-0.5 italic">Computer Generated Receipt</p>
                                            <p className="text-[8px] font-bold text-slate-400 italic">No signature required for digital verification.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </motion.div>
                    </div>
                )}
            </AnimatePresence>

            <div className="fixed bottom-16 left-0 w-full p-4 bg-white/80 backdrop-blur-md border-t border-slate-200 z-10 flex justify-center">
                <button
                    disabled={processingPayment || totalAmount === 0}
                    className={`w-full max-w-md text-white font-bold py-4 rounded-xl shadow-lg transition-all active:scale-95 flex justify-between items-center px-6
                    ${totalAmount > 0 && !processingPayment ? 'bg-pragyaBlue hover:bg-opacity-90 shadow-pragyaBlue/20' : 'bg-slate-300 cursor-not-allowed'}
                  `}
                    onClick={handlePayNow}
                >
                    <div className="flex flex-col items-start">
                        <span className="text-[10px] uppercase opacity-80 font-medium">Total Payable</span>
                        <span className="text-lg">₹{totalAmount}</span>
                    </div>
                    <div className="flex items-center gap-2">
                        {processingPayment ? (
                            <>
                                <span className="text-sm">Processing...</span>
                                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                            </>
                        ) : (
                            <>
                                <span className="text-sm">Pay Now</span>
                                <FaChevronUp className="rotate-90 text-xs" />
                            </>
                        )}
                    </div>
                </button>
            </div>
        </motion.div>
    );
}

export default Payments;
